module.exports = __webpack_public_path__ + "static/media/dsc_9107.230756e8.jpg";